import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={181}
    height={39}
    fill="none"
    {...props}
  >
    <foreignObject width={188.214} height={45.793} x={-4} y={-3.75}>
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(2px)",
          clipPath: "url(#aededed)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <rect
      width={179.214}
      height={36.793}
      x={0.5}
      y={0.75}
      fill="url(#bededed)"
      stroke="url(#cededed)"
      data-figma-bg-blur-radius={4}
      rx={18.396}
    />
    <path
      fill="#fff"
      d="m78.441 15.762 1.024-.368c.16.32.315.666.464 1.04.15.373.278.736.384 1.088.117.34.192.645.224.912l-1.088.432a7.164 7.164 0 0 0-.224-.928c-.096-.363-.213-.731-.352-1.104a8.98 8.98 0 0 0-.432-1.072Zm-1.52 4.144 1.04-.24c.107.522.198 1.093.272 1.712.075.618.128 1.152.16 1.6l-1.12.288c-.01-.47-.053-1.014-.128-1.632a29.009 29.009 0 0 0-.224-1.728Zm-1.696-.144 1.152.192a29.205 29.205 0 0 1-.304 2.096 12.767 12.767 0 0 1-.448 1.808 3.48 3.48 0 0 0-.544-.24c-.224-.075-.41-.134-.56-.176.181-.48.326-1.051.432-1.712.117-.662.208-1.318.272-1.968Zm-.24-4.272a4.02 4.02 0 0 0-.112-.352 4.226 4.226 0 0 0-.16-.48 16.26 16.26 0 0 0-.144-.416c.128-.043.261-.14.4-.288.15-.15.304-.347.464-.592a11 11 0 0 0 .512-.848c.246-.416.496-.902.752-1.456.267-.555.496-1.12.688-1.696l1.264.528c-.384.885-.826 1.76-1.328 2.624-.49.864-.992 1.616-1.504 2.256v.032l-.128.064c-.074.042-.17.1-.288.176a2.148 2.148 0 0 0-.288.24c-.085.074-.128.144-.128.208Zm.016-.032-.032-.992.608-.4 2.752-.224a4.567 4.567 0 0 0-.096.592c-.021.213-.037.389-.048.528-.821.085-1.445.16-1.872.224-.427.064-.73.117-.912.16-.17.032-.304.069-.4.112Zm.096 3.696a3.225 3.225 0 0 0-.112-.368c-.043-.16-.09-.32-.144-.48a2.858 2.858 0 0 0-.16-.416c.181-.043.363-.16.544-.352.181-.192.39-.438.624-.736.128-.15.315-.395.56-.736.245-.342.517-.747.816-1.216.31-.48.614-.992.912-1.536.31-.555.587-1.104.832-1.648l1.152.704a24.126 24.126 0 0 1-1.264 2.192 29.867 29.867 0 0 1-1.44 2.08c-.49.65-.987 1.248-1.488 1.792v.032s-.043.02-.128.064c-.075.042-.17.1-.288.176a1.487 1.487 0 0 0-.288.224c-.085.074-.128.149-.128.224Zm0 0-.048-1.024.624-.432 4.192-.576a4.32 4.32 0 0 0-.064.576c0 .213.005.389.016.528-.96.149-1.733.277-2.32.384-.587.096-1.04.176-1.36.24-.31.064-.538.117-.688.16-.15.042-.266.09-.352.144Zm3.52.416.992-.336c.15.405.294.848.432 1.328.15.469.261.88.336 1.232l-1.056.4c-.053-.363-.15-.79-.288-1.28-.139-.491-.277-.94-.416-1.344Zm2.224-9.12h1.36v3.936c0 .672-.016 1.424-.048 2.256-.032.832-.096 1.69-.192 2.576a25.999 25.999 0 0 1-.384 2.608 12.88 12.88 0 0 1-.656 2.32 2.137 2.137 0 0 0-.352-.272 8.394 8.394 0 0 0-.448-.256 2.22 2.22 0 0 0-.4-.16c.256-.683.459-1.414.608-2.192.16-.78.272-1.574.336-2.384.075-.811.123-1.6.144-2.368.022-.78.032-1.483.032-2.112V10.45Zm3.344 7.04h.864v6.496h-.864V17.49Zm1.776 0h.88v6.416h-.88V17.49Zm-4.304-5.216h6.944v3.728h-6.944v-1.184h5.616v-1.36h-5.616v-1.184Zm.48 4.672h6.16v1.232h-5.04v6.032h-1.12v-7.264Zm5.648 0h1.184v5.968c0 .256-.026.458-.08.608a.804.804 0 0 1-.304.384c-.16.085-.341.138-.544.16a6.534 6.534 0 0 1-.704.032 2.355 2.355 0 0 0-.112-.528 4.41 4.41 0 0 0-.192-.512c.139.01.267.016.384.016.117 0 .203-.006.256-.016.075 0 .112-.048.112-.144v-5.968Zm-5.04 2.784h5.456v1.216h-5.456V19.73Zm4.736-10.368 1.136 1.008c-.672.202-1.424.384-2.256.544-.832.149-1.69.277-2.576.384-.874.106-1.728.192-2.56.256a4.64 4.64 0 0 0-.16-.544 4.344 4.344 0 0 0-.224-.56c.79-.064 1.595-.15 2.416-.256a51.747 51.747 0 0 0 2.352-.384c.747-.14 1.37-.288 1.872-.448Zm15.776 5.216h1.408v9.616h-1.408v-9.616Zm-3.36-3.648v1.344h3.328V10.93h-3.328Zm-1.424-1.088h6.24v3.536h-6.24V9.842Zm-.896 4.352h7.984v1.216h-7.984v-1.216Zm1.632 2.384h4.736v1.104h-4.736v-1.104Zm0 2.288h4.736v1.104h-4.736v-1.104Zm-.656-4.336h1.392v7.104l-1.392.144V14.53Zm-7.712-3.536h6.64v1.328h-6.64v-1.328Zm-.176 9.184h7.008v1.328h-7.008v-1.328Zm2.832-10.832h1.36v4.512h-1.36V9.346Zm.144 4.544h1.072v4.576h.144v5.744h-1.36v-5.744h.144V13.89Zm-1.28 2.816v1.232h3.696v-1.232h-3.696Zm0-2.256v1.216h3.696V14.45h-3.696Zm-1.136-1.088h6v5.664h-6v-5.664Zm6.112 7.808h8.176v1.344h-8.176V21.17Z"
    />
    <defs>
      <linearGradient
        id="bededed"
        x1={90.107}
        x2={90.107}
        y1={0.25}
        y2={38.043}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C866B" />
        <stop offset={0.14} stopColor="#8F896D" stopOpacity={0.96} />
        <stop offset={0.32} stopColor="#999274" stopOpacity={0.84} />
        <stop offset={0.53} stopColor="#A9A07F" stopOpacity={0.8} />
        <stop offset={1} stopColor="#999274" stopOpacity={0.4} />
      </linearGradient>
      <linearGradient
        id="cededed"
        x1={7.406}
        x2={105.016}
        y1={16.3}
        y2={103.993}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.08} stopColor="#8C866B" />
        <stop offset={0.26} stopColor="#8C866A" />
        <stop offset={0.45} stopColor="#F5E6B6" />
        <stop offset={0.59} stopColor="#7D7649" />
        <stop offset={0.84} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
      <clipPath id="aededed" transform="translate(4 3.75)">
        <rect width={179.214} height={36.793} x={0.5} y={0.75} rx={18.396} />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
